import React, {
  useEffect,
  useState,
} from 'react'
import axios from 'axios'
import { parseString } from 'xml2js'
import { toast } from 'react-toastify'

import isDebug from 'utils/isDebug'

import {
  Page,
  PageProps,
  XmlSitemap,
} from './types'

import SiteMap from './index.presentational'

const SiteMapContainer: React.FC = (): React.ReactElement => {
  const [
    loading,
    setLoading,
  ] = useState(true)
  const [
    pages,
    setPages,
  ] = useState([] as PageProps[])

  useEffect(() => {
    axios
      .request({
        url: '/sitemap.xml',
        method: 'GET',
      })
      .then(
        response =>
          (response.status >= 200 &&
            response.status < 300 &&
            response.data) ||
          undefined,
      )
      .then(xml => {
        parseString(xml, (err: Error, data: XmlSitemap) => {
          if (err || !data || !data.urlset || !data.urlset.url) {
            throw new Error('Unable to parse XML.')
          }

          const pages = data.urlset.url.map((page: Page) => ({
            ...page,
            absoluteUrl: page.loc[0],
            relativeUrl: page.loc[0].replace(/^.*:\/\/[^/]*\//, '/'),
          })) as PageProps[]

          setPages(pages)
          setLoading(false)
        })
      })
      .catch(error => {
        const errorMessage =
          'An error occurred trying to read the site data. Please try again'
        toast(`${errorMessage}${(isDebug && error) || undefined}`)

        setLoading(false)
      })
  }, [])

  return React.createElement(SiteMap, {
    loading,
    pages,
  })
}

export default SiteMapContainer
